// extracted by mini-css-extract-plugin
export default {"wrap":"DayCounter_wrap__D55Ip","headline":"DayCounter_headline__kgecN"};